(function($){

	$(document).ready(function(){
		process_intro_module();
		home_services_slider();
		clients_testimonials_slider();
		client_info_slider();
		resources_statistics_slider();
		initiate_ticker();
		events_slider();
		featured_in_guide_slider();
		ap_statistics_slider();
		ap_locations_slider();
		ap_ourteam_slider();
		
		$('body').on('click','.accordion--trigger',function(e) {
			$(this).toggleClass('open');
			$(this).parent().toggleClass('open');
			$(this).siblings('.accordion--content').slideToggle();
		});

		$('body').on('click','.popup--trigger',function(e) {
			e.preventDefault();
			$('#allplaces--popup').fadeIn();
		});

		$('body').on('click','.popup-close--trigger',function(e) {
			e.preventDefault();
			$('#allplaces--popup').fadeOut();
		});

		$('body').on('click','.client-title--item',function(e) {
			$(this).addClass('active').siblings().removeClass('active');
			var $target = $(this).data('target');

			$('.client-info').removeClass('active');
			
			setTimeout(function(){ 
				$('.client-info').addClass('moveaway');
				$('#' + $target).removeClass('moveaway').addClass('active'); 
			}, 400);
		});

		$('body').on('click','.services-item-additional-title',function(e){
			$(this).toggleClass('active');
			$(this).siblings('.services-item-additional-content').slideToggle();
		});

		$('body').on('click','.mobile-menu--trigger',function(e){
			e.preventDefault();
			$(this).toggleClass('open');
			$('#mobile-menu').toggleClass('active');
		});

		$('body').on('click','.newsletter-form--trigger', function(e){
			var $current_trigger = $(this);
		  	$current_trigger.find('.newsletter-label').addClass('hideit');
		  	$current_trigger.find('.allplaces-newsletter-form').addClass('shown');
		  	
		  	setTimeout(function(){
		  		$current_trigger.find('.allplaces-newsletter-form').find('#k_id_email').focus();
		  	}, 300);
		});

		var scrolled = false;

		$('#ap--intro-module').on("mousewheel DOMMouseScroll", function(e) {
			e.preventDefault();

			if(!scrolled) {
				scrolled = true;
			    if (e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0) {
			      
			    } else {
			    	setup_stage();
			    }
			}
	  	});

	  	$('#ap--intro-module').bind('touchmove', function(e) { 
  			e.preventDefault();

  			if(!scrolled) {
				scrolled = true;
  				setup_stage();
  			}
		});

		$(window).on('load',function() {
			process_cookies_banner();
		});

		$(window).on('load resize scroll',function() {
			var y = $(this).scrollTop();
			var element = $('#site-header');

			if(y > 0 && element.length && ! element.hasClass('scroll')) {
				element.addClass('scroll');
			}

			if(y <= 0 && element.length) {
				element.removeClass('scroll');
			}
		});

		$(window).on('resize',function(){
			home_services_slider();
			client_info_slider();
		});

		$(document).on('click','#cookies-banner .action-menu li a',function(e){
			e.preventDefault();
			$('#cookies-banner').removeClass('active');
			sessionStorage.setItem('cookies_banner_shown', 'yes');
		});

		$(document).on('click','#clients-menu__mobile-trigger',function(e){
			e.preventDefault();
			$(this).parent('#clients-menu__mobile').toggleClass('open');
		});

		$(document).on('click','#clients-menu__content ul li',function(e){
			e.preventDefault();
			$(this).addClass('active').siblings().removeClass('active');
			$("#client-info--slider").slick('slickGoTo',$(this).index());
			$(this).parents('#clients-menu__mobile').removeClass('open');
		});

		$(document).on('click','.faqs .js-load-more',function(e){
			e.preventDefault();
			$faqs = $(this).parents('.faqs');
			$faqs_size = $faqs.find('.accordion--group').size();

			$visible_elements_size = $faqs.find('.accordion--group:visible').size();
			$visible_elements_size = $visible_elements_size + 5 <= $faqs_size ? $visible_elements_size + 5 : $faqs_size;

			$faqs.find('.accordion--group:lt(' + $visible_elements_size + ')').show();

			if($visible_elements_size >= $faqs_size) {
				$(this).fadeOut();
			}
		});

	});

	function setup_stage() {
		$('#ap--intro-module').addClass('push');
		$('#site-header').addClass('active');
		$('#site-header').removeClass('push');
		$('.main-content').addClass('active').removeClass('push');

		setTimeout(function(){
			$('#PageContainer').removeClass('fixed'); 
			$('#ap--intro-module').remove();
		}, 2000);
	}

	function process_intro_module() {
		var $site_header = $('#site-header');
		var $page_container = $('#PageContainer');
		var $main_content = $('#PageContainer .main-content');
		var $intro_module = $('#ap--intro-module');

		if($('body').hasClass('template-index')) {
			if(sessionStorage.getItem('intro_shown') != 'yes') {
				$intro_module.addClass('active');
				sessionStorage.setItem('intro_shown', 'yes');
				$page_container.addClass('fixed');
				$site_header.addClass('push');
				$main_content.addClass('push');
			} else {
				$site_header.addClass('active');
				$site_header.removeClass('push');
				$intro_module.addClass('push');
				$main_content.addClass('active');
			}
		} else {
			$site_header.addClass('active');
			$site_header.removeClass('push');
		}
	}

	function home_services_slider() {
		
		if($('#home-services--slider').length) {

			if(!$('#home-services--slider').hasClass('slick-initialized') && $(window).width() > 991) {

				$("#home-services--slider").slick({
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        arrows: false,
			        dots: false,
			        infinite: true,
			        autoplay: false,
			        pauseOnHover: false,
			        pauseOnFocus: false,
			        fade: true,

			        responsive: [
			        	{
			        		breakpoint: 992,
			        		settings: "unslick"
			        	}
			        ]
			    });

			    $('body').on('click','.custom-slick-prev',function(e){
			    	$('#home-services--slider').slick('slickPrev');
			    });

			    $('body').on('click','.custom-slick-next',function(e){
			    	$('#home-services--slider').slick('slickNext');
			    });
			}
		}
	}

	function clients_testimonials_slider() {
		
		if($('.testimonials-slider').length) {

			if(!$('.testimonials-slider').hasClass('slick-initialized')) {

				$(".testimonials-slider").slick({
			        slidesToShow: 4,
			        slidesToScroll: 1,
			        arrows: false,
			        dots: false,
			        infinite: true,
			        autoplay: true,
			        pauseOnHover: false,
			        pauseOnFocus: false,

			        responsive: [
			        	{
			        		breakpoint: 1200,
			        		settings: {
			        			slidesToShow: 3.1,
			        			slidesToScroll: 1
			        		}
			        	},
			        	{
			        		breakpoint: 768,
			        		settings: {
			        			slidesToShow: 2.1,
			        			slidesToScroll: 1
			        		}
			        	},
			        	{
			        		breakpoint: 550,
			        		settings: {
			        			slidesToShow: 1,
			        			slidesToScroll: 1,
			        			centerMode: true
			        		}
			        	}				        
			        ]
			    });

			}
		}
	}

	function client_info_slider() {
		
		if($('#client-info--slider').length) {

			$('#client-info--slider').on('afterChange', function(event, slick, currentSlide){
				$('#clients-menu__content ul li').removeClass('active');
				$('#clients-menu__content ul li:nth-child(' + (currentSlide + 1) + ')').addClass('active');
			});

			if(!$('#client-info--slider').hasClass('slick-initialized')) {

				$("#client-info--slider").slick({
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: false,
			        infinite: false,
			        autoplay: false,
			        pauseOnHover: false,
			        pauseOnFocus: false,
			        mobileFirst: true,
			        adaptiveHeight: true,
			        prevArrow: '<img src=\'//www.allplaces.com/cdn/shop/t/11/assets/slick-prev.svg?v=165716960562619883201764956170\' class="slick-prev">',
			        nextArrow: '<img src=\'//www.allplaces.com/cdn/shop/t/11/assets/slick-next.svg?v=8879713904053150891764956170\' class="slick-next">',

			        responsive: [
			        	{
			        		breakpoint: 768,
			        		settings: "unslick"
			        	}		        
			        ]
			    });

			}
		}
	}

	function resources_statistics_slider() {
		
		if($('#resources-statistics--slider').length) {

			var $status = $('#slider-pagingInfo');
			var $slickElement = $('#resources-statistics--slider');

			$slickElement.on('init reInit', function(event, slick, currentSlide, nextSlide){
			    var i = (currentSlide ? currentSlide : 0) + 1;
			    $status.text(i + '/' + slick.slideCount);
			});

			$slickElement.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				var i = nextSlide + 1;
			    $status.text(i + '/' + slick.slideCount);
			});



			if(!$('#resources-statistics--slider').hasClass('slick-initialized')) {

				$("#resources-statistics--slider").slick({
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: false,
			        infinite: false,
			        autoplay: true,
			        autoplaySpeed: 4000,
			        pauseOnHover: false,
			        pauseOnFocus: false,
			        fade: true,
			        prevArrow: '<img src=\'//www.allplaces.com/cdn/shop/t/11/assets/slick-prev.svg?v=165716960562619883201764956170\' class="slick-prev">',
			        nextArrow: '<img src=\'//www.allplaces.com/cdn/shop/t/11/assets/slick-next.svg?v=8879713904053150891764956170\' class="slick-next">',
			        appendArrows: '#resources-statistics--slider-navigation'
			    });

			}
		}
	}

	function process_cookies_banner() {
		if($('#cookies-banner').length && sessionStorage.getItem('cookies_banner_shown') != 'yes') {
			setTimeout(function(){
				$('#cookies-banner').addClass('active');
			}, 2000);
		}
	}

	function initiate_ticker() {
		var $tickerWrapper = $('#events-marquee__slider-container');
		var $list = $tickerWrapper.find('.scroll');
		var $clonedList = $list.clone();
		var listWidth = 0;

		$list.find('.marquee-text').each(function(i) {
			listWidth += $(this, i).outerWidth(true);
		});

		var endPos = $tickerWrapper.width() - listWidth;

		$list.add($clonedList).css({
			width: listWidth + 'px',
		});

		$clonedList.addClass('cloned').appendTo($tickerWrapper);

		//TimelineMax

		var infinite = new TimelineMax({ repeat: -1, paused: true });
		var time = $tickerWrapper.data('speed');

		if($(window).width() < 768) {
			time = $tickerWrapper.data('mobileSpeed');
		}

		infinite
			.fromTo(
				$list,
				time,
				{ rotation: 0.01, x: 0 },
				{ force3D: true, x: -listWidth, ease: Linear.easeNone },
				0
			)
			.fromTo(
				$clonedList,
				time,
				{ rotation: 0.01, x: listWidth },
				{ force3D: true, x: 0, ease: Linear.easeNone },
				0
			)
			.set($list, { force3D: true, rotation: 0.01, x: listWidth })
			.to(
				$clonedList,
				time,
				{
					force3D: true,
					rotation: 0.01,
					x: -listWidth,
					ease: Linear.easeNone,
				},
				time
			)
			.to(
				$list,
				time,
				{
					force3D: true,
					rotation: 0.01,
					x: 0,
					ease: Linear.easeNone,
				},
				time
			)
			.progress(1)
			.progress(0);

		infinite.play();
	}

	function events_slider() {
		
		if($('#events-slick__slider').length) {

			var $prev_item = $('#events-slick__slider').siblings('#events-slick__slider-navigation').find('.slick-prev');
			var $next_item = $('#events-slick__slider').siblings('#events-slick__slider-navigation').find('.slick-next');

			if(!$('#events-slick__slider').hasClass('slick-initialized')) {

				$("#events-slick__slider").slick({
			        slidesToShow: 3,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: false,
			        infinite: false,
			        autoplay: false,
			        prevArrow: $prev_item,
			        nextArrow: $next_item,
			        responsive: [
			        	{
			        		breakpoint: 992,
			        		settings: {
			        			slidesToShow: 1,
			        			slidesToScroll: 1
			        		}
			        	}
			        ]
			    });
			}
		}
	}

	function featured_in_guide_slider() {
		
		if($('#featured-in-guide__slider').length) {

			if(!$('#featured-in-guide__slider').hasClass('slick-initialized')) {

				$prevArrow = $('#featured-in-guide__slider').siblings('#featured-in-guide__slider-navigation').find('.prev-arrow');
	 			$nextArrow = $('#featured-in-guide__slider').siblings('#featured-in-guide__slider-navigation').find('.next-arrow');
	 			$current = $('#featured-in-guide__slider-navigation').find('.current');

				$("#featured-in-guide__slider").slick({
			        slidesToShow: 3,
			        slidesToScroll: 3,
			        arrows: true,
			        dots: false,
			        infinite: false,
			        autoplay: false,
	 				prevArrow: $prevArrow,
	 				nextArrow: $nextArrow,

			        responsive: [
			        	{
			        		breakpoint: 1200,
			        		settings: {
			        			slidesToShow: 2,
			        			slidesToScroll: 2
			        		}
			        	},
			        	{
			        		breakpoint: 768,
			        		settings: {
			        			slidesToShow: 1.2,
			        			slidesToScroll: 1
			        		}
			        	}				        
			        ]
			    }).on('afterChange', function(event, slick, currentSlide){
			    	$current.text(currentSlide + 1);
			    });

			}
		}
	}


	function ap_statistics_slider() {
		
		if($('.ap-statistics-slider__slider').length) {

			$('.ap-statistics-slider__slider').each(function(){

				var $navigation = $(this).siblings('.ap-statistics-slider__navigation')
				var $pager = $(this).siblings('.ap-statistics-slider__pagingInfo');
				var $slickElement = $(this);

				$slickElement.on('init reInit', function(event, slick, currentSlide, nextSlide){
				    var i = (currentSlide ? currentSlide : 0) + 1;
				    $pager.text(i + '/' + slick.slideCount);
				});

				$slickElement.on('beforeChange', function(event, slick, currentSlide, nextSlide){
					var i = nextSlide + 1;
				    $pager.text(i + '/' + slick.slideCount);
				});



				if(!$(this).hasClass('slick-initialized')) {

					$(this).slick({
				        slidesToShow: 1,
				        slidesToScroll: 1,
				        arrows: true,
				        dots: false,
				        infinite: true,
				        autoplay: true,
				        autoplaySpeed: 4000,
				        pauseOnHover: false,
				        pauseOnFocus: false,
				        fade: true,
				        prevArrow: '<img src=\'//www.allplaces.com/cdn/shop/t/11/assets/slick-prev.svg?v=165716960562619883201764956170\' class="slick-prev">',
				        nextArrow: '<img src=\'//www.allplaces.com/cdn/shop/t/11/assets/slick-next.svg?v=8879713904053150891764956170\' class="slick-next">',
				        appendArrows: $navigation
				    });

				}

			});	
		}
	}


	function ap_locations_slider() {
		
		if($('.ap-locations-slider__slider').length) {

			$('.ap-locations-slider__slider').each(function(){

				var $prev_item = $(this).siblings('.ap-locations-slider__navigation').find('.slick-prev');
				var $next_item = $(this).siblings('.ap-locations-slider__navigation').find('.slick-next');

				if(!$(this).hasClass('slick-initialized')) {

					$(this).slick({
				        slidesToShow: 1,
				        slidesToScroll: 1,
				        arrows: true,
				        dots: false,
				        infinite: true,
				        autoplay: true,
				        autoplaySpeed: 4000,
				        fade: true,
				        prevArrow: $prev_item,
				        nextArrow: $next_item
				    });
				}
			});
		}
	}


	function ap_ourteam_slider() {
		
		if($('.ap-ourteam__slider').length) {

			$('.ap-ourteam__slider').each(function(){

				var $prev_item = $(this).siblings('.ap-ourteam__slider-navigation').find('.slick-prev');
				var $next_item = $(this).siblings('.ap-ourteam__slider-navigation').find('.slick-next');

				if(!$(this).hasClass('slick-initialized')) {

					$(this).slick({
				        slidesToShow: 1,
				        slidesToScroll: 1,
				        arrows: true,
				        dots: false,
				        infinite: true,
				        variableWidth: true,
				        prevArrow: $prev_item,
				        nextArrow: $next_item
				    });
				}
			});
		}
	}

})(jQuery);